import React from 'react';
import { Modal, Button } from '../../teacher/components/shared/UI';

export const LEVEL_APPEAL_EMAIL = 'ossdancefest@gmail.com';

/**
 * Submit-time block shown when an entry's level is below the recommended
 * level (see getRecommendedLevelIfBelow in EntryFormFields.js). Entries can't
 * be saved below it — a lower level goes through an emailed appeal instead.
 * Shared between the teacher's EntryEditor and the public choreographer
 * submission page. Callers wrap the conditional render in <AnimatePresence>.
 */
export default function LevelWarningModal({ level, recommendedLevel, onClose }) {
  return (
    <Modal onClose={onClose}>
      <div style={{ padding: '14px 18px', borderBottom: '1px solid #E5E5E5', fontSize: 15, fontWeight: 500 }}>
        Level below recommendation
      </div>
      <div style={{ padding: '14px 18px', fontSize: 13, color: '#1A1A1A', lineHeight: 1.5 }}>
        This entry is registered at <strong>{level}</strong>, which is below the average experience level of its
        participants. Please change the level to <strong>{recommendedLevel}</strong> or higher before saving.
        <br /><br />
        If you believe this entry should compete at a lower level, save it at {recommendedLevel} and send an appeal
        to <a href={`mailto:${LEVEL_APPEAL_EMAIL}`} style={{ color: '#185FA5' }}>{LEVEL_APPEAL_EMAIL}</a> explaining why.
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '10px 18px', borderTop: '1px solid #E5E5E5', flexWrap: 'wrap' }}>
        <Button variant="primary" onClick={onClose}>Go back and fix level</Button>
      </div>
    </Modal>
  );
}
